export type Bonus = {
  number: string
  emoji: string
  title: string
  description: string
  points: string[]
  value: string
  image: string
  imageAlt: string
}

export const bonuses: Bonus[] = [
  {
    number: 'PREMIUM SYSTEM #1',
    emoji: '🔧',
    title: 'PRODUCTIVE WORKSHOP SYSTEM™',
    description:
      'Turn almost any workspace into an organized repair environment that helps you finish more repairs in less time.',
    points: [
      '5S method adapted for repair workshops.',
      'Smart tool organization.',
      'Parts organization.',
      'Recommended workflow.',
      'Daily productivity checklist.',
    ],
    value: '$37 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/hkEcRbGtJDq3MEYnV88NK8/BONUS_1_REPARACIONES-EN.png',
    imageAlt: 'Productive Workshop System bonus product box',
  },
  {
    number: 'PREMIUM SYSTEM #2',
    emoji: '💰',
    title: 'SMART BUYING SYSTEM™',
    description:
      'Buy replacement parts like a professional technician and increase your profit without performing a single additional repair.',
    points: [
      'Supplier directory.',
      'Price comparison tools.',
      'Negotiation methods.',
      'Supplier evaluation.',
      'Smart purchasing strategy.',
    ],
    value: '$47 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/jX2eQ5jDpMZhMuiH6aqXru/BONUS_2_REPARACIONES-EN.png',
    imageAlt: 'Smart Buying System bonus product box',
  },
  {
    number: 'PREMIUM SYSTEM #3',
    emoji: '🛡️',
    title: 'BULLETPROOF WARRANTY SYSTEM™',
    description:
      'Protect your reputation, reduce warranty conflicts and create professional warranty conditions your customers can understand.',
    points: [
      'Warranty forms.',
      'Coverage conditions.',
      'Complaint protocols.',
      'Customer communication scripts.',
      'Real-world examples.',
    ],
    value: '$47 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/2gGeqYh58nH3HP3MvZtVe4/BONUS_3_REPARACIONES-EN.png',
    imageAlt: 'Bulletproof Warranty System bonus product box',
  },
  {
    number: 'PREMIUM SYSTEM #4',
    emoji: '📈',
    title: 'REAL PROFIT SYSTEM™',
    description:
      "Discover how much money you're losing without realizing it — and calculate the true profit behind every repair.",
    points: [
      'Cost calculator.',
      'Hidden expenses.',
      'Unbilled time.',
      'Operating costs.',
      'Real profit calculation.',
    ],
    value: '$37 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/myMP1KAVYXoWLCg4snkMj2/BONUS_4_REPARACIONES-EN.png',
    imageAlt: 'Real Profit System bonus product box',
  },
  {
    number: 'PREMIUM SYSTEM #5',
    emoji: '📲',
    title: 'WHATSAPP SELLING SYSTEM™',
    description:
      'Turn your WhatsApp into a professional customer communication system that helps you respond, quote and follow up while you’re working.',
    points: [
      'Automated messages.',
      'Fast quotation templates.',
      'Optimized service catalog.',
      'Customer follow-up.',
      'Closing scripts.',
    ],
    value: '$67 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/t9k6BTjVZVYuRHtNGUSoj5/BONUS_5_REPARACIONES-EN.png',
    imageAlt: 'WhatsApp Selling System bonus product box',
  },
]

export const valueStack: { label: string; value: string; bonus?: boolean }[] = [
  { label: 'System #1 · Set Up Your Appliance Repair Business', value: '$97' },
  { label: 'System #2 · Charge Like a Premium Technician', value: '$67' },
  { label: 'System #3 · Repairs Without the Chaos', value: '$67' },
  { label: 'System #4 · Customers Who Refer You', value: '$47' },
  { label: 'System #5 · Customers Every Month', value: '$67' },
  { label: 'System #6 · Business Ready to Operate', value: '$97' },
  { label: '🔧 Productive Workshop System™', value: '$37', bonus: true },
  { label: '💰 Smart Buying System™', value: '$47', bonus: true },
  { label: '🛡️ Bulletproof Warranty System™', value: '$47', bonus: true },
  { label: '📈 Real Profit System™', value: '$37', bonus: true },
  { label: '📲 WhatsApp Selling System™', value: '$67', bonus: true },
]
